import { render, staticRenderFns } from "./Sendings.vue?vue&type=template&id=75793283&"
import script from "./Sendings.vue?vue&type=script&lang=js&"
export * from "./Sendings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports